import * as React from 'react';
import {
    Button,
    Col,
    Row,
} from 'reactstrap';

import {
    Tooltip
} from '@mui/material';

import ErrorIcon from '@mui/icons-material/ErrorRounded';

import { AddUsersMode } from './CommonUser';

import { PortalTextSettings, PortalTextCommon } from '../../../Models/Api/strongbox.financialportal';

type Props = {
    onInviteUser: () => void;
    addEnabled: boolean;
    allowMetadata: boolean;
    invalidUserMetadata: boolean;
    changeEditMode: (newMode: AddUsersMode) => void;
    mode: AddUsersMode;
    settingsText?: PortalTextSettings;
    commonText?: PortalTextCommon;
}

export const AddUserInfoButtonsRow: React.FC<Props> = (props): React.ReactElement => {
    const {
        addEnabled,
        allowMetadata,
        onInviteUser,
        invalidUserMetadata,
        changeEditMode,
        mode,
        settingsText,
        commonText,
    } = props;

    const modeButtonStyle: React.CSSProperties = {
        marginRight: '15px'
    }

    return (
        <Row className={'user-metadata-button-row'}>
            <Col xs={12}>
                <Button
                    color="primary"
                    onClick={() => {
                        onInviteUser();
                    }}
                    disabled={!addEnabled}
                    className={'small'}
                >
                    {commonText?.add || ''}
                </Button>
                {
                    allowMetadata && (mode === 'editrequired') && (
                        <Tooltip title={invalidUserMetadata ? (settingsText?.addUserOneOrMoreFieldsHaveInvalidContent || '') : ''}>
                            <span>
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        changeEditMode('editmetadata');
                                    }}
                                    className={'small'}
                                    style={modeButtonStyle}
                                >
                                    {settingsText?.addUserEditOptionalData || ''}
                                    {
                                        invalidUserMetadata && (
                                            <ErrorIcon
                                                style={{
                                                    marginLeft: '10px'
                                                }}
                                            />
                                        )
                                    }
                                </Button>
                            </span>
                        </Tooltip>
                    )
                }
                {
                    allowMetadata && (mode === 'editmetadata') &&  (
                        <Button
                            color="primary"
                            onClick={() => {
                                changeEditMode('editrequired');
                            }}
                            className={'small'}
                            style={modeButtonStyle}
                        >
                            {settingsText?.addUserEditRequiredFields || ''}
                        </Button>
                    )
                }
            </Col>
        </Row>
    );
}
